import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref } from "vue"

const _hoisted_1 = { class: "popular-queries__item q-list-group-item q-d-flex q-justify-content-between q-align-items-start q-p-1 q-text-start" }
const _hoisted_2 = ["href"]

import {inject} from 'vue'

import {useUrlStore} from "@/store/SerpPage/UrlStore";

import {useUserRecentQueriesStore} from "@/store/AutocompletePopup/UserRecentQueriesStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'QueriesItem',
  props: ['queryItem', 'index', 'canRemove'],
  setup(__props) {



const urlStore = useUrlStore()
const SmartSearchConfig = inject('SmartSearchConfig').value;
const {redirectionUrl} = SmartSearchConfig.appConfiguration

const userRecentQueriesStore = useUserRecentQueriesStore()

const handleQueryClick = (query: string) => {
  const cleaned = (query || '').trim();
  if (!cleaned) return;
  
  urlStore.goToSerpPage(
      redirectionUrl,
      cleaned
  );
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (__props.queryItem?.link)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "q-text-decoration-none q-link-secondary popular-queries__item-link",
          href: __props.queryItem?.link
        }, _toDisplayString(__props.queryItem.query), 9, _hoisted_2))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "q-text-decoration-none q-link-secondary popular-queries__item-link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleQueryClick(__props.queryItem.query)), ["stop"]))
        }, _toDisplayString(__props.queryItem.query), 1)),
    (__props.canRemove)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(userRecentQueriesStore).removeQuery(__props.index)), ["stop"])),
          type: "button",
          class: "remove-query__button q-btn q-btn-close q-btn-sm",
          "aria-label": "Remove"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})